import React, { useEffect, useState } from 'react';
import styles from '../Tracker/index.module.scss';
import { useParams } from 'react-router-dom';
import { tracker } from '../../../services/tracker';
import { MealGroup as MealGroupModel } from '../../../models/tracks/mealGroup';
import MealGroup from '../../modules/MealGroup';
import { analyticsApi } from '../../../services/analytics';

const AddMeal = () => {
  const { trackId, groupId } = useParams<{
    trackId: string;
    groupId: string;
  }>();

  const [mealGroup, setMealGroup] = useState<MealGroupModel>();

  const forceUpdate: () => void = React.useState()[1].bind(null, {})

  useEffect(() => {
    fetchGroup(trackId, groupId);
    analyticsApi.logEvent(
      '',
      'Subview',
      {},
      'Add New Meal Opened'
    );
  }, []);

  const fetchGroup = async (trackId: string, mealId: string) => {
    const data = await tracker.getGroup(trackId, mealId);
    if (data) {
      setMealGroup(new MealGroupModel(data));
    }
  };

  const onRemoveMeal = () => {
    forceUpdate()
  }

  return (
    <>
      <div className={styles.body}>
        {mealGroup && <MealGroup trackId={trackId} mealGroup={mealGroup} includeSearch={true} onRemoveMeal={onRemoveMeal} />}
      </div>
    </>
  );
};

export default AddMeal;
